export function copyToClipboard(cnt) {
  navigator.clipboard.writeText(cnt);
}